'use client'
import React from 'react'
import DiscoverHeroSection from './components/DiscoverHeroSection'
import { BusinessGrow, ContactUsForm } from '@/components'
import VisionMission from './components/VisionMission'
import OurCoreValues from './components/OurCoreValues'
import AverageDevShop from './components/AverageDevShop'
import Foundations from './components/Foundations'
import Marquee from './components/Marquee'
import WhyBetOnUs from './components/WhyBetOnUs'
import StillHere from './components/StillHere'
import Milestones from './components/Milestones'

function AboutUsPage() {
   return (
      <>
         <DiscoverHeroSection />
         <BusinessGrow />
         <VisionMission />
         <OurCoreValues />
         <AverageDevShop />
         <Foundations />
         <Marquee />
         <WhyBetOnUs />
         <StillHere />
         <Milestones />
         <ContactUsForm />
      </>
   )
}

export default AboutUsPage
